import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { AccurateDateIntervalWithShift } from '@wilson/interfaces';
import {
  GanttDateToPositionPxPipe,
  GanttEndingPixelPipe,
  GanttStartingPixelPipe,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  GanttShiftEndTimePipe,
  GanttShiftStartTimePipe,
  ShiftTimelinePipesModule,
} from '@wilson/shift-timeline/pipes';
import { MouseMovementHelperService } from '../../services/mouse-movement-helper.service';

@Component({
  selector: 'wilson-activity-snap-line-v2',
  imports: [CommonModule, ShiftTimelinePipesModule],
  template: `
    @if (shiftView) {
      <div class="activityDropZone">
        @if (mouseMovementHelperService.snapPx$ | async; as snappingLeftPx) {
          <div class="snapping-line" [style.left.px]="snappingLeftPx"></div>
        }
      </div>
    }
  `,
  styleUrls: ['./activity-snap-line-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    GanttShiftStartTimePipe,
    GanttShiftEndTimePipe,
    GanttStartingPixelPipe,
    GanttDateToPositionPxPipe,
    GanttEndingPixelPipe,
  ],
})
export class ActivitySnapLineV2Component {
  readonly mouseMovementHelperService = inject(MouseMovementHelperService);

  @Input() userId!: string | undefined;
  @Input() shiftView!: AccurateDateIntervalWithShift | null | undefined;
}
